import getCurrentSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import getTableViewFromTableQuery from 'mini-mail-list-store/lib/actions/tables/getTableViewFromTableQuery';
import { createSearchTableQuery } from '../utils/createSearchTableQuery';
import { getSearchSourceFromConfig } from 'mini-search-common/lib/utils/getSearchSourceFromConfig';
import { orchestrator } from 'satcheljs';
import { removeTableView } from 'mini-mail-list-actions';
import { setSelectedTableViewId } from 'mini-mail-list-actions/lib/actions/tables/setSelectedTableViewId';
import { switchMailSearchFolderScope } from '../actions/publicActions';
import {
    executeMailSearch,
    incrementSearchNumber,
    setCurrentFolderScopeId,
    setSearchSource,
} from '../actions/privateActions';

/**
 * Orchestrator which is triggered when a folder change happens. It removes previous
 * search TableView and and creates a new search tableView and triggers executeMailSearch.
 */
export default orchestrator(switchMailSearchFolderScope, actionMessage => {
    const { folderScopeId } = actionMessage;
    const selectedTableView = getCurrentSelectedTableView();

    setCurrentFolderScopeId(folderScopeId);
    incrementSearchNumber();

    /**Set the correct search source based on userSetting */
    const searchSourceToBeUsed = getSearchSourceFromConfig();
    setSearchSource(searchSourceToBeUsed);

    /** create and get a new tableView */
    const newSearchTableQuery = createSearchTableQuery();
    const newTableView = getTableViewFromTableQuery(newSearchTableQuery);
    setSelectedTableViewId(newTableView.id);

    removeTableView(selectedTableView);

    executeMailSearch();
});
